import React, { useState, useEffect } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { MotifButton } from "@ey-xd/motif-react";
import FileFetcher from "./SPFolderUpload";
import logger from "../../common/utils/logger";

export default function SelectSharePoint({sharePointFiles, isSPLoading, open, onClose, setSPPayload ,rowData, SetSelectedSPFiles,SetHandleAttach}) {
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [selectedFolders, setSelectedFolders] = useState([]);
  const [sizeCheck, setSizeCheck] = useState(null);

  useEffect(() => {
    if (open) {
      SetHandleAttach(false);
    }
    if (!open) {
      setSelectedFiles([]);
      setSelectedFolders([]);
    }
  }, [open]);

  const isAnyItemSelected = () => {
    return selectedFiles.length > 0 || selectedFolders.length > 0;
  };

  const handleAttach = () => {
    if (selectedFiles.length === 0 && selectedFolders.length === 0) {
      // Handle case where no files or folders are selected
      logger.info("No files or folders selected");
    } else {
      const result = {
        files: selectedFiles,
        folders: selectedFolders,
      };
      setSPPayload(result);
    }
    SetHandleAttach(true);
    SetSelectedSPFiles(selectedFiles);
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <style>
        {`
          .close-hover:hover {
            background-color: #d5d5deff !important;
          }
        `}
      </style>
      <DialogTitle style={{ padding: "14px 20px", fontSize: "18px" }}>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div>
            <div style={{ fontWeight: 600 }}>Attach files from SharePoint</div>
            <div style={{ fontSize: "13px", color: "#777" }}>
              Engagement ID: <span style={{ color: "#4169e1" }}>{rowData?.engagementId}</span>
            </div>
          </div>
          <IconButton onClick={onClose} className="close-hover" style={{ width: "30px", height: "30px" }}><CloseIcon /></IconButton>
        </div>
      </DialogTitle>

      <DialogContent style={{ padding: "10px 24px", maxHeight: "500px", overflowY: "auto" }}>
        <FileFetcher
          onStateChange={(payload) => { setSPPayload(payload); }}
          onSelectionChange={({ selectedFiles, selectedFolders }) => {
            setSelectedFiles(selectedFiles);
            setSelectedFolders(selectedFolders);
          }}
          seletcedSPFiles={selectedFiles}
          sharePointFiles={sharePointFiles}
          isSPLoading={isSPLoading}
          onFileSizeCheck={(size) => setSizeCheck(size)}
        />
      </DialogContent>

      <DialogActions style={{ padding: "10px 24px" }}>
        <MotifButton variant="secondary" onClick={onClose} style={{ fontSize: "13px", padding: "6px 14px" }}>
          Cancel
        </MotifButton>
        <MotifButton
          variant="primary"
          onClick={handleAttach}
          disabled={!isAnyItemSelected() || sizeCheck}
          style={{ fontSize: "13px", padding: "6px 14px" }}
        >
          Attach
        </MotifButton>
      </DialogActions>
    </Dialog>
  );
}
